<template>
  <div class="promotion-detail" v-if="promotion">
    <section class="mt-5">
      <div class="banner" :style="util.getImageStyle(promotion.imgPath)"></div>
    </section>
    <section-header class="mt-5 mb-5" :title="promotion.actName" subtitle="Promotion"/>
    <section>
      <div class="desc" v-html="util.getHtml(promotion.actDesc)"></div>
    </section>
    <section class="mt-5" v-if="products">
      <!--
      <list-control-panel :layout="view.layout" @layout="onLayoutChanged"/>
      -->
      <product-grid class="mt-5" v-show="view.layout === layoutOptions.GRID" :products="products"/>
      <product-list class="mt-5" v-show="view.layout === layoutOptions.LIST" :products="products"/>
    </section>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import promotionApi from '@/api/promotion.js'
import productApi from '@/api/product.js'
import SectionHeader from '@/components/SectionHeader.vue'
// import ListControlPanel from '@/components/ListControlPanel.vue'
import ProductGrid from '@/components/Product/ProductGrid.vue'
import ProductList from '@/components/Product/ProductList.vue'

export default {
  name: 'PromotionDetail',
  components: {
    SectionHeader,
    // ListControlPanel,
    ProductGrid,
    ProductList
  },
  data: function () {
    return {
      view: {
        layout: 'grid'
      },
      promotion: null,
      products: null
    }
  },
  computed: {
    util: function () {
      return util
    },
    promotionId: function () {
      return Number(this.$route.params.id)
    },
    layoutOptions: function () {
      return constant.PRODUCT_LAYOUT
    }
  },
  mounted: function () {
    if (this.promotionId) {
      this.apiGetPromotion()
      this.apiGetPromotionProducts()
    }
  },
  methods: {
    apiGetPromotion: function () {
      var self = this
      promotionApi.getPromotion(this.promotionId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.promotion = rspData
      })
    },
    apiGetPromotionProducts: function () {
      var self = this
      productApi.getPromotionProducts(this.promotionId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.products = rspData
      })
    },
    onLayoutChanged: function (value) {
      if (!value) {
        return
      }
      this.view.layout = value
    }
  }
}
</script>

<style scoped>
.banner {
  width: 100%;
  padding-bottom: 50%;
}
.desc {
  font-size: 1.1rem;
  font-weight: 500;
}

@media screen and (max-width: 767px) {
  .promotion-detail >>> .section-header .title {
    font-size: 2rem;
  }
}
</style>
